export const PIX_AND_GO_FINAL_STATUSES = [
  "completed",
  "user_registration_failed",
  "deposit_failed",
];

export const PIX_AND_GO_PROCESSING_STATUSES = [
  "registering_user",
  "deposit_in_progress",
];

export const PIX_AND_GO_FORM_REQUIRED_STATUS = "form_required";
